import { StoreState } from "..";

export const getIndexCampaigns = (state: StoreState) => state.indexCampaigns;
